import { createFileRoute } from '@tanstack/react-router'

import { listTaxonomiesOptions } from '@/api/codegen/@tanstack/react-query.gen'
import { ValidationRuleCreatePage } from '@/pages/taxonomy/ValidationRuleCreate.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/create',
)({
  component: ValidationRuleCreatePage,
  loader: ({ context: { queryClient }, params: { spaceId } }) => {
    queryClient.ensureQueryData(
      listTaxonomiesOptions({
        path: {
          spaceID: spaceId,
        },
      }),
    )

    return { breadcrumbTitle: 'Create validation rule' }
  },
})
